import React, {useState} from 'react';

import StripedProgressBar from "./components/striped-progress-bar";
import {useSelector} from "react-redux";
import Countdown from "./components/count-down";
import {useTranslate} from "./useTranslate";

function UnderConstruction(props) {
    const translate=useTranslate();
    const {config} = useSelector((state) => state.app);

    const [countDownFinished, setCountDownFinished] = useState(false);
    return (
        <div className="flex flex-column justify-content-between w-full h-full surface-ground">
            <StripedProgressBar value={100} height={50} color="orange" striped animated={true} />
            <div className="w-full h-full flex flex-column gap-2 align-items-center justify-content-center">
                <span className="pi pi-cog text-yellow-400 pi-spin text-8xl"/>
                <h3 className={`text-7xl m-0 ${config.dir}`}>
                    {countDownFinished?translate("count-down-finished"):<Countdown targetDate={config["under-construction"]} onComplete={() => setCountDownFinished(true)}/>}
                </h3>
                {/*<span className="text-4xl">Page Not Found</span>*/}
                <span className="text-4xl">{translate("under-construction")}</span>
            </div>
            <StripedProgressBar value={100} height={50} color="orange" striped animated={true} />

        </div>

    );
}

export default UnderConstruction;